import { RouterProvider } from "react-router";
import { router } from "./routes";
import { PlatformCapabilitiesProvider } from "@shared-core/capabilities/context";
import { SupplierPortalAdapterProvider } from "@shared-core/data/SupplierPortalAdapterContext";
import type {
  SupplierPortalDataAdapter,
  SupplierPortalSignInAdapter,
} from "@shared-core/data/supplier-portal-adapter";
import type { SupplierPicksAdapter } from "@shared-core/data/supplier-picks-adapter";
import type { SupplierGoodsInAdapter } from "@shared-core/data/supplier-goods-in-adapter";
import { webCapabilities } from "../platform/capabilities";

export interface AppProps {
  /** The purchase-order half of the portal (orders, invoices, account, the order page): the supplier app, or the
   * mock. */
  data: SupplierPortalDataAdapter;
  /** The login half of supplier access: Entra External ID through the supplier app, or the mock. */
  signIn: SupplierPortalSignInAdapter;
  /** Warehouse picks: the supplier app's `/supplier-api/picks`, or the mock. */
  picks: SupplierPicksAdapter;
  /** Warehouse goods in: the supplier app's `/supplier-api/goods-in`, or the mock. */
  goodsIn: SupplierGoodsInAdapter;
}

/** App shell for the supplier portal. `main.tsx` picks the adapters and hands them in. */
export function App({ data, signIn, picks, goodsIn }: AppProps) {
  return (
    <PlatformCapabilitiesProvider capabilities={webCapabilities}>
      <SupplierPortalAdapterProvider
        data={data}
        signIn={signIn}
        picks={picks}
        goodsIn={goodsIn}
      >
        <RouterProvider router={router} />
      </SupplierPortalAdapterProvider>
    </PlatformCapabilitiesProvider>
  );
}
